// extracted by mini-css-extract-plugin
module.exports = {"roundedContainer":"styles_roundedContainer__zczkl"};